import { z } from 'zod';
import { TransactionType } from '@/features/transactions/types/transactions-dto';
import { t } from 'i18next';

export const TransactionsInvoicePopupFormSchema = z.object({  
  startDate: z
    .date()
    .nullable()
    .optional(),
  endDate: z
    .date()
    .nullable()
    .optional(),
  apartmentId: z
    .array(z.object({
      id: z.string(),
      name: z.string().optional()
    }))
    .optional(),
  account: z
    .nativeEnum(TransactionType)
    .nullable()
    .optional(),
}).refine(
  (data) =>
    data.startDate && data.endDate
      ? data.endDate >= data.startDate
      : true,
  {
    message: t('elements.form.datesDifference.error'),
    path: ['endDate'],
  },
);